/**
 * Manual APK launch notice — edit this file whenever you ship a new Android build.
 *
 * The APK is generated locally, then uploaded to DigitalOcean Spaces via the
 * backend (`npm run android:apk`). Do not save DigiQin.apk in the frontend
 * (repo root, public/apk, static/apk, or build/apk).
 *
 * Landing modal downloads from GET /api/apk/download (backend → Space).
 */

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api'
).replace(/\/$/, '');

export const APK_RELEASE = {
  /** Set to false to hide the landing-page highlight and modal. */
  enabled: true,

  /** Short highlight label shown on the landing page. */
  highlightLabel: 'New Android App',

  /** Modal title. */
  title: 'DigiQin Android App',

  /** Short supporting line under the title. */
  subtitle: 'Logistics in your pocket — book, track, and manage shipments from Android.',

  /** Version shown in the modal (optional display only). */
  version: '1.0.0',

  /** Optional size label shown near the download button. */
  fileSizeLabel: 'Android APK',

  /** Platform chips shown in the modal. */
  platforms: ['Android 8+', 'Offline-ready UI', 'Secure login'],

  /** Update notes — edit these lines for each release. */
  updates: [
    'First public Android release of DigiQin.',
    'Track shipments, manage bookings, and work on the go.',
    'Install the APK and allow installs from this source if prompted.',
  ],

  /** Interactive install steps shown in the modal. */
  installSteps: [
    {
      title: 'Download the APK',
      detail: 'Tap Download APK below. The file saves to your device Downloads folder.',
    },
    {
      title: 'Allow install from this source',
      detail: 'Open the file and allow install permission for your browser or file manager when Android asks.',
    },
    {
      title: 'Install & open DigiQin',
      detail: 'Complete install, then open DigiQin and sign in with your existing business account.',
    },
  ],

  /** Download file name shown in the modal and used by the browser. */
  fileName: 'DigiQin.apk',
};

/** Stable backend URL — redirects to the Space object, replacing it on every publish. */
export const apkDownloadUrl = () => `${API_BASE_URL}/apk/download`;
